import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'MovCore',
  brandName: 'MovCore',
  description: 'Sistema de agendamento para fisioterapeutas',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Clínica de fisioterapia',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Sessão de fisioterapia',
  },
  testimonials: [
    {
      name: 'Dr. Tiago Matos',
      role: 'Fisioterapeuta',
      text: 'O MovCore simplificou a gestão de pacientes e marcações. Agora tenho mais tempo para me dedicar à recuperação deles.',
      image: testimonial1,
    },
    {
      name: 'Joana Guimarães',
      role: 'Paciente',
      text: 'Marcar as minhas sessões de fisioterapia online é uma grande ajuda. O sistema é muito fácil de usar.',
      image: testimonial2,
    },
    {
      name: 'Clínica Fisiovida',
      role: 'Diretor Clínico',
      text: 'A taxa de comparência às sessões aumentou significativamente com os lembretes automáticos. Recomendo!',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'fisioterapeuta',
    professionals: 'fisioterapeutas',
    business: 'clínica',
    businesses: 'clínicas',
    service: 'sessão',
    services: 'sessões',
    client: 'paciente',
    clients: 'pacientes',
    appointment: 'sessão',
    appointments: 'sessões',
  },
  homepage: {
    hero: {
      badge: 'Solução para Fisioterapeutas',
      title: 'Otimize sua clínica com MovCore',
      description: 'Simplifique o agendamento de sessões e foque na recuperação dos seus pacientes.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
      features: ['Sem cartão de crédito', 'Configuração em 5 minutos'],
    },
    statistics: [
      { value: '120+', label: 'Clínicas' },
      { value: '18k+', label: 'Sessões' },
      { value: '96%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Controlo Manual de Sessões',
        description: 'Gerir agendas em papel ou sistemas desatualizados gera conflitos e atrasos no tratamento.',
        icon: 'Calendar',
        quote: {
          text: 'Antes do MovCore perdia 45 minutos diários organizando a agenda e controlando sessões',
          author: 'Dr.ª Ana Pereira',
          business: 'Clínica MoviSaúde',
        },
      },
      {
        title: 'Ausências Sem Aviso',
        description: 'Pacientes que faltam sem avisar comprometem a continuidade do tratamento e geram horários perdidos.',
        icon: 'Users',
        stats: [
          { label: 'Taxa de ausência sem lembretes:', value: '35%' },
          { label: 'Horários perdidos por semana:', value: '12+' },
        ],
      },
      {
        title: 'Dificuldade de Acompanhamento',
        description: 'Sem registro digital, é difícil acompanhar a evolução e frequência dos tratamentos.',
        icon: 'TrendingUp',
        quote: {
          text: 'O histórico digital das sessões melhorou 70% a qualidade dos meus diagnósticos',
          author: 'Dr. Carlos Fonseca',
          business: 'Fisiocenter',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'MovCore: Tecnologia para acelerar a recuperação',
      description: 'Simplifique a gestão da sua clínica e ofereça um atendimento mais eficiente aos seus pacientes.',
      features: [
        {
          title: 'Agendamento Online de Sessões',
          description: 'Pacientes marcam sessões 24h por dia, respeitando sua disponibilidade.',
        },
        {
          title: 'Histórico de Tratamentos',
          description: 'Registe e acompanhe a evolução completa de cada paciente.',
        },
        {
          title: 'Lembretes de Sessão',
          description: 'Reduza faltas com lembretes automáticos personalizados.',
        },
      ],
    },
    testimonials: {
      title: 'Depoimentos dos nossos fisioterapeutas',
      description: 'Profissionais que confiam no MovCore para otimizar seus tratamentos.',
    },
    finalCta: {
      title: 'Pronto para acelerar a recuperação?',
      description: 'Junte-se a fisioterapeutas que já otimizaram sua clínica com o MovCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Conversar com Especialista',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de fisioterapeuta',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config
